import React from 'react';

import * as styles from './ContentOverlay.styles';
import { useSiteChromeDynamicContext } from 'client-site-chrome-ui/context/SiteChromeDynamicContext/useSiteChromeDynamicContext';

export const ContentOverlay = () => {
  const {
    contentOverlay: { isDisplayed, top },
  } = useSiteChromeDynamicContext();

  return isDisplayed ? (
    <div
      css={styles.overlay}
      data-testid="content-overlay"
      style={{ '--overlayTop': top } as styles.OverlayCSS}
    />
  ) : null;
};
